import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Paper,
  IconButton,
  Collapse,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';

import i18n from '../../i18n';

import '../../assets/stylesheets/ScheduleView.css';

class SideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expandView: true
    };
  }

  handleExpandClick = () => {
    this.setState(prevState => ({ expandView: !prevState.expandView }));
  };

  render() {
    const { expandView } = this.state;
    const { positionNames } = this.props;
    return (
      <Paper className="blockContainer">
        <div className="blockHeader">
          <h5>{i18n.t('schedule:sideMenu')}</h5>
          <IconButton
            className={expandView ? 'expandView' : ''}
            onClick={this.handleExpandClick}
            aria-expanded={expandView}
            aria-label={i18n.t('schedule:showMore')}
          >
            <ExpandMore color="secondary" />
          </IconButton>
        </div>
        <Collapse in={expandView} timeout="auto">
          <List component="nav" aria-label={i18n.t('schedule:sideMenu')}>
            {positionNames.map(positionName => {
              return (
                <ListItem
                  button
                  component="a"
                  href={`#${positionName}`}
                  key={positionName}
                >
                  <ListItemText primary={i18n.t(`positions:${positionName}`)} />
                </ListItem>
              );
            })}
          </List>
        </Collapse>
      </Paper>
    );
  }
}

SideMenu.propTypes = {
  positionNames: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default SideMenu;
